if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      if (!this.openedBy) return;

      const openedMediaId = this.openedBy.getAttribute('data-media-id');
      if (!openedMediaId) return;

      const mediaId = openedMediaId.split('-').pop();

      const swiperElement = this.querySelector('.product-media-modal-swiper');
      if (!swiperElement) return;

      const swiper = swiperElement.swiper;
      if (!swiper) return;


      const slides = Array.from(
        swiperElement.querySelectorAll(
          '.swiper-slide:not(.swiper-slide-duplicate)'
        )
      );

      const targetSlide = slides.find((slide) => {
        const media = slide.querySelector('[data-media-id]');
        if (!media) return false;

        const targetMediaId = media.getAttribute('data-media-id');

        return (
          targetMediaId === openedMediaId ||
          targetMediaId === mediaId ||
          openedMediaId.endsWith(targetMediaId)
        );
      });

      if (!targetSlide) return;

      const slideIndex = Number(
        targetSlide.getAttribute('data-swiper-slide-index')
      );

      swiper.slideToLoop(slideIndex, 0, false);

      this.querySelectorAll('[data-media-id]').forEach((media) => {
        media.classList.remove('active');
      });

      const activeMedia = targetSlide.querySelector('[data-media-id]');
      if (activeMedia) {
        activeMedia.classList.add('active');
      }
    }
  });
}
